import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function FAQSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="w-full py-24 px-6 bg-[#111111] border-t border-[#333]" data-id="element-9">
      <div className="max-w-3xl w-full mx-auto space-y-12" data-id="element-10">
        {/* Label */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-11">
          <span className="text-[#D4A853] text-xs md:text-sm tracking-[0.2em] uppercase font-medium border-b border-[#D4A853]/30 pb-1" data-id="element-12">
            PREGUNTAS FRECUENTES
          </span>
        </motion.div>

        {/* FAQ Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="space-y-8" data-id="element-13">
          {/* FAQ 1 */}
          <motion.div variants={itemVariants} className="bg-[#0D0D0D] p-6 rounded-lg border-l-2 border-[#D4A853]" data-id="element-14">
            <h3 className="text-xl font-serif text-[#F5F0E8] italic mb-3" data-id="element-15">
              «No tengo tiempo»
            </h3>
            <p className="text-[#A89F91] leading-relaxed" data-id="element-16">
              Por eso los retos toman solo 15 minutos al día.
            </p>
          </motion.div>

          {/* FAQ 2 */}
          <motion.div variants={itemVariants} className="bg-[#0D0D0D] p-6 rounded-lg border-l-2 border-[#D4A853]" data-id="element-17">
            <h3 className="text-xl font-serif text-[#F5F0E8] italic mb-3" data-id="element-18">
              «¿Es difícil?»
            </h3>
            <p className="text-[#A89F91] leading-relaxed" data-id="element-19">
              No. Es práctico y directo.
            </p>
          </motion.div>

          {/* FAQ 3 */}
          <motion.div variants={itemVariants} className="bg-[#0D0D0D] p-6 rounded-lg border-l-2 border-[#D4A853]" data-id="element-20">
            <h3 className="text-xl font-serif text-[#F5F0E8] italic mb-3" data-id="element-21">
              «¿Funciona si tengo hijos/trabajo estresante?»
            </h3>
            <p className="text-[#A89F91] leading-relaxed" data-id="element-22">
              Está diseñado específicamente para mujeres con alta
              responsabilidad.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}